module.exports = __webpack_public_path__ + "img/emojione_light-bulb.f32ff0bc.svg";